/**
 * "2 hours ago" / "3 days ago" for posted items (announcements). Persona
 * round 2026-10: the ribbon said "just now" for anything under an hour and
 * otherwise used terse "3h ago" / "2w ago". Whole units, rounded down;
 * "just now" only for under a minute (or a timestamp slightly in the
 * future from clock drift). Past 30 days it is the date itself, in India
 * time (formatDate), since "5 months ago" is less useful than the date.
 */
import { formatDate } from "@/lib/format";

const MIN = 60_000;
const HOUR = 60 * MIN;
const DAY = 24 * HOUR;

const plural = (n: number, unit: string) => `${n} ${unit}${n === 1 ? "" : "s"} ago`;

export function relativeTime(iso: string | null | undefined, now: number = Date.now()): string {
  if (!iso) return "";
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return "";
  const diff = now - t;
  if (diff < MIN) return "just now";
  if (diff < HOUR) return plural(Math.floor(diff / MIN), "minute");
  if (diff < DAY) return plural(Math.floor(diff / HOUR), "hour");
  const days = Math.floor(diff / DAY);
  if (days === 1) return "yesterday";
  if (days < 7) return plural(days, "day");
  if (days < 30) return plural(Math.floor(days / 7), "week");
  return formatDate(iso);
}
